<lib-match-reporter-banner></lib-match-reporter-banner>
<div class="info-card {{colorScheme.main}}" *ngIf="matchInfos">
  <div class="table">
    <ng-container *ngFor="let info of matchInfos">
      <div class="t-row" *ngIf="info.visible">
        <mat-icon>{{ info.icon }}</mat-icon>
        <span *ngIf="!info.link">{{ info.text }}</span>
        <a *ngIf="info.link" target="_blank" [href]="info.link">{{ info.text }}</a>
        <span *ngIf="info.subText">, {{ info.subText }}</span>
      </div>
    </ng-container>
  </div>
</div>

<lib-match-betting-game *ngIf="showBettingGame"></lib-match-betting-game>

<h3 *ngIf="sponsors?.length > 0">Sponsoren</h3>
<div *ngIf="sponsors?.length > 0" class="info-card">
  <ng-container *ngFor="let sponsor of sponsors">
    <a *ngIf="sponsor.pictures?.length > 0"
       class="match-sponsor"
       target="_blank"
       [matTooltip]="sponsor.name"
       [href]="sponsor.url">
      <img *ngIf="sponsor.pictures"
           [src]="sponsor.pictures | imageUrlBySubtype : 'image'"
           [alt]="sponsor.name">
    </a>
  </ng-container>
</div>
<lib-hero-banner style="margin-bottom: 32px"
                 linkPath="spiele"
                 [disableVotingBanner]="true"
                 [hasTopShadow]="false"></lib-hero-banner>
